import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import CheckBox from '../../Shared/CheckBox/Checkbox';
import { connect } from 'react-redux';
import { setIsShowConfirmPopUpTermsMsg,setErrorConfirmPopUpTermsMsg } from './GenericVasSlice';


function PopUpConfirmation(props) {
    const {isPopUp, contentData, footerButton} = props;
    const { popUpContentList, privateTitlePupUp, privateTextCheckBox } = contentData;

    let content = popUpContentList?.value?.map((item,i)=>
        <div className='content' key={i}>
            <Image src={require('./images/icon-v.svg')} alt="איקון של וי" />
            <p>{item.textListPopUp}</p>
        </div>
    );

    let termsAcceptHolder = (isAccepted) => {
        if(isAccepted === true) {
            props.setErrorConfirmPopUpTermsMsg('')
        }
        props.setIsShowConfirmPopUpTermsMsg(isAccepted);
        props.setIsShowConfirmTermsMsg(false);
    };

    return (
        <>
            {isPopUp &&
                <div className='wrapper-pup-up-content'> 
                    <Image src={require('./images/icon-pupup.svg')} alt='תמונת מנורה' />
                    { privateTitlePupUp?.value && <h2>{privateTitlePupUp?.value}</h2> }
                    { content }
                    <div className='service-terms'>
                        <div className='service-terms-checkbox'> 
                            <CheckBox
                                id='pop-up-confirmation'
                                error={props?.errorConfirmPopUpTermsMsg }
                                label={ privateTextCheckBox.value }
                                onCheck={() => {
                                    termsAcceptHolder(true);
                                }}
                                onUncheck={() => {
                                    termsAcceptHolder(false);
                                }}
                            >
                            </CheckBox>
                        </div>
                    </div>
                    { footerButton && <div className='footerButton'>{ footerButton }</div> }
                </div>
            }
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        errorConfirmPopUpTermsMsg: state.genericVasBlock.errorConfirmPopUpTermsMsg,
        isShowConfirmPopUpTermsMsg: state.genericVasBlock.isShowConfirmPopUpTermsMsg,
    };
  };
  
  const mapDispatchToProps = {
    setIsShowConfirmPopUpTermsMsg,
    setErrorConfirmPopUpTermsMsg
  };
  

// export default PopUpConfirmation;
export default connect(mapStateToProps, mapDispatchToProps)(PopUpConfirmation); 